import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBrand, pubFromHostname, FOOTER_IMAGE, LOVE_IN_FULL_LOGO, PUB_SITES, LOVE_IN_FULL_SITE, HeroPicture } from "../lib/brand";

/**
 * Public page footer: black-and-white image, LOGIN link, copyright + contact
 * emails, and EXPLORE logo buttons to the three family sites (new tab).
 */
const EDITOR_EMAILS = {
  dwh: "editor@dancingwithher.com",
  dwt: "editor@dancingwiththem.com",
};

export default function SiteFooter({ pub = null }) {
  const [brand, setBrand] = useState({});
  useEffect(() => {
    let live = true;
    getBrand().then((b) => { if (live) setBrand(b || {}); });
    return () => { live = false; };
  }, []);
  const effectivePub = pub || pubFromHostname(brand);

  const explore = [
    { key: "dwh", href: PUB_SITES.dwh, logo: brand.dwh_logo_url, label: "Dancing With Her" },
    { key: "dwt", href: PUB_SITES.dwt, logo: brand.dwt_logo_url, label: "Dancing With Them" },
    { key: "lif", href: LOVE_IN_FULL_SITE, logo: LOVE_IN_FULL_LOGO, label: "Love, in Full" },
  ];

  return (
    <footer className="relative w-full overflow-hidden mt-auto" data-testid="site-footer">
      <HeroPicture base={FOOTER_IMAGE} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-white/45" />
      <div className="relative min-h-[300px] flex flex-col sm:flex-row items-stretch justify-between gap-8 px-5 sm:px-8 py-8">
        <div className="flex flex-col justify-end text-black">
          <Link to="/login" className="text-xs font-bold uppercase tracking-[0.2em] mb-3" data-testid="footer-login-link">
            Login
          </Link>
          <p className="text-xs font-bold" data-testid="footer-copyright">© Behind the Love</p>
          <p className="text-xs mt-1">
            <a href="mailto:hello@dancingwithher.com" className="hover:underline" data-testid="footer-email-dwh">hello@dancingwithher.com</a>
            <span className="mx-2">|</span>
            <a href="mailto:hello@dancingwiththem.com" className="hover:underline" data-testid="footer-email-dwt">hello@dancingwiththem.com</a>
          </p>
        </div>
        <div className="flex flex-col items-start sm:items-end justify-center gap-2">
          <p className="text-[0.7rem] font-bold uppercase tracking-[0.25em] text-black" data-testid="footer-explore-label">Explore</p>
          {explore.map((e) => (
            <a
              key={e.key}
              href={e.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`footer-explore-${e.key}`}
              className="bg-white rounded-full border border-black/10 px-6 py-2 flex items-center justify-center min-w-[190px] hover:opacity-85 transition-opacity"
            >
              {e.logo ? (
                <img src={e.logo} alt={e.label} className="h-6 w-auto object-contain" />
              ) : (
                <span className="text-xs font-bold uppercase tracking-widest text-black">{e.label}</span>
              )}
            </a>
          ))}
        </div>
      </div>
      {/* Legal line — on every public page */}
      <div className="relative bg-[#f5f3ed] border-t border-[#dcd3c6] px-5 sm:px-8 py-5 text-center">
        <p className="text-xs text-black" data-testid="footer-legal">
          © 2026 Dancing With Her® · Dancing With Them® · ABN 21 440 059 775 ·
          Bendigo VIC, Australia ·{" "}
          <Link to="/privacy" className="underline" data-testid="footer-privacy">Privacy</Link> ·{" "}
          <Link to="/terms" className="underline" data-testid="footer-terms">Terms</Link> ·{" "}
          <Link to="/cookies" className="underline" data-testid="footer-cookies">Cookies</Link> ·{" "}
          <a href={`mailto:${EDITOR_EMAILS[effectivePub] || EDITOR_EMAILS.dwh}`} className="underline" data-testid="footer-editor-email">
            {EDITOR_EMAILS[effectivePub] || EDITOR_EMAILS.dwh}
          </a>
        </p>
        <p className="text-[10px] text-black/70 mt-1" data-testid="footer-trademark">
          Dancing With Her® and Dancing With Them® are registered trademarks.
        </p>
      </div>
    </footer>
  );
}
